module.exports = __webpack_public_path__ + "static/img/zhibogif.60663376.gif";